import colors from 'vuetify/lib/util/colors'

export default {
  primary: {
    base: '#01458e',
  },

  secondary: colors.teal.base,
  
}